import styled, { css } from 'styled-components';
import {
  mq,
  getSpace,
  getColor,
  getGridSpan,
  getGridColumns,
  setGridColumns,
  gridContainer,
  getGridRows
} from '../../../stylesheets/tools';

const StyledBasicTeaser = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${getSpace('m')};

  ${mq('m')} {
    width: ${props => (props.size === 's' ? getGridSpan(6) : '100%')};
  }

  .basicTeaser__arrow {
    margin-top: 20px;

    ${mq('m')} {
      opacity: 0;
      visibility: hidden;
    }

    svg {
      width: 34px;

      ${mq('m')} {
        width: 60px;
      }
    }
  }

  .basicTeaser__link {
    ${gridContainer()}
    ${setGridColumns('1fr', 12)}
    grid-gap: 10px;
    grid-row-gap: 0;

    ${mq('m')} {
      ${props => props.size === 's' && setGridColumns('1fr', 6)};

      &:hover .basicTeaser__arrow {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .basicTeaser__image-wrapper {
    position: relative;
    padding-bottom: ${props => (props.orientation === 'portrait' ? '133.333%' : '75%')};
    height: 0;
    background: ${getColor('lightGray')};
    animation: loadingBg 1s linear infinite alternate;

    img {
      position: absolute;
      height: 100%;
      width: 100%;
    }
  }

  .basicTeaser__background-wrapper {
    position: relative;
    color: ${props => props.theme.globalTheme.borderColor};
    height: 0;
    padding-bottom: ${props =>
      props.orientation === 'landscape' ? 'calc(275 / 576 * 100%)' : 'calc(551 / 576 * 100%)'};

    svg {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .basicTeaser__mask {
    position: relative;
    background-color: #fff;
    clip-path: polygon(86% 5%, 100% 29%, 95% 100%, 0 100%, 0 0);
    max-height: 300px;
  }

  .basicTeaser__background,
  .basicTeaser__content {
    position: relative;
  }

  .basicTeaser__headlines {
    h1 {
      margin-top: 20px;
      padding-right: 40px;

      ${mq('m')} {
        padding-right: 0;
      }
    }
    h2 {
      margin-bottom: ${getSpace('s')};
    }
    h3 {
      margin-bottom: ${getSpace('xs')};
    }
  }

  ${props =>
    props.size === 's' &&
    css`
      .basicTeaser__background {
        ${getGridRows(1)}

        ${mq('m')} {
          padding-right: 40px;
        }
      }

      .basicTeaser__mask,
      .basicTeaser__content {
        ${getGridRows([1, 2])}
      }

      .basicTeaser__content {
        padding: 50px 30px 0 0;

        ${mq('m')} {
          padding: 60px 60px 0 40px;
        }
      }

      ${props.orientation === 'landscape' &&
        css`
          .basicTeaser__background {
            ${getGridColumns([1, 13], { m: [1, 7] })}
          }

          .basicTeaser__mask {
            ${getGridColumns([1, 12], { m: [1, 6] })}
          }

          .basicTeaser__content {
            ${getGridColumns([2, 12], { m: [1, 6] })}
          }

          .basicTeaser__mask,
          .basicTeaser__content {
            margin-top: ${props.image ? '120px' : '100px'};

            ${mq('m')} {
              margin-top: ${props.image ? '164px' : '134px'};
            }
          }
        `}

      ${props.orientation === 'portrait' &&
        css`
          .basicTeaser__background {
            ${getGridColumns([5, 13], { m: [2, 7] })}
          }

          .basicTeaser__mask {
            ${getGridColumns([1, 12], { m: [1, props.image ? 6 : 5] })}
          }

          .basicTeaser__content {
            ${getGridColumns([2, 12], { m: [1, props.image ? 6 : 5] })}
          }

          .basicTeaser__mask,
          .basicTeaser__content {
            margin-top: ${props.image ? '120px' : '100px'};

            ${mq('m')} {
              margin-top: ${props.image ? '274px' : '174px'};
            }
          }
        `}
    `}

  ${props =>
    props.size === 'm' &&
    css`
      .basicTeaser__background {
        ${getGridColumns([2, 13], { m: [6, 13] })}
        ${getGridRows(1)}
        right: -26px;

        ${mq('m')} {
          right: 0;
        }
      }

      .basicTeaser__mask {
        ${getGridColumns([1, 12], { m: [1, 9] })}
        ${getGridRows([1, 2])};
      }

      .basicTeaser__content {
        ${getGridColumns([2, 12], { m: [2, 8] })}
        ${getGridRows([1, 2])}
        padding-top: 50px;

        ${mq('m')} {
          padding-top: 40px;
        }
      }

      .basicTeaser__mask,
      .basicTeaser__content {
        margin-top: 96px;

        ${mq('m')} {
          margin-top: 84px;
        }
      }
    `}
`;

export default StyledBasicTeaser;
